
function bmProgressBar() {
	var winScroll = document.body.scrollTop || document.documentElement.scrollTop;
	var height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
	var scrolled = (winScroll / height) * 100;
	var progressbar = document.getElementById("bm-Scroll-Progress-Bar");
	if( progressbar ){
		progressbar.style.width = scrolled + "%";
	}
}

window.addEventListener('scroll', bmProgressBar);
